import {applyMiddleware, compose, createStore } from 'redux';
import { Reducer } from 'react';
import reducers from './reducers';
import { combineReducers, AnyAction } from '@reduxjs/toolkit'
import {connectRouter, routerMiddleware, RouterState} from 'connected-react-router';
import thunk from 'redux-thunk';
import { setAuthToken } from '../utils';

const createBrowserHistory = require('history').createBrowserHistory;
const history = createBrowserHistory();

const rootReducer = combineReducers({
  ...reducers,
  router: connectRouter(history) as Reducer<RouterState, AnyAction>,
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore(initialState?: AppState) {
  const middlewares = [thunk, routerMiddleware(history)];
  
  const enhancers = [];
  const windowIfDefined =
    typeof window === 'undefined' ? null : (window as any);
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }
  
  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middlewares), ...enhancers),
  );

  // if (module.hot) {
  //   // Enable Webpack hot module replacement for reducers
  //   module.hot.accept('./reducers', () => {
  //     const nextRootReducer = require('./reducers');
  //     store.replaceReducer(nextRootReducer);
  //   });
  // }

  let currentState = store.getState();
  store.subscribe(() => {
    // keep track of the previous and current state to compare changesAppLayout/index.j
    let previousState = currentState;
    currentState = store.getState();
    // if the token changes set the value in localStorage and axios headers
    if (previousState.auth.token !== currentState.auth.token) {
      const token = currentState.auth.token;
      const refresh = currentState.auth.refreshToken;
      setAuthToken(token, refresh);
    }
  });
  
  return store
}
export { history }
